export interface TelegramWebApp {
  initData: string;
  ready(): void;
  expand(): void;
}

export interface TelegramWindow {
  Telegram?: {
    WebApp?: TelegramWebApp;
  };
}

export function initializeTelegramMiniApp(telegramWindow: TelegramWindow = window as unknown as TelegramWindow): string | null {
  const webApp = telegramWindow.Telegram?.WebApp;
  if (!webApp) return null;

  webApp.ready();
  webApp.expand();

  const initData = webApp.initData.trim();
  return initData.length > 0 ? initData : null;
}
